/* Welcome popup behaviour, ported from The Whole Bowl.

   The rule it exists to obey: never cover the first screen. It opens only once
   the hero has been scrolled past, with a long timed fallback for someone who
   never scrolls, and it remembers that it has been shown. */
(() => {
  const KEY = 'anyra-welcome-seen';
  const start = () => {
    const pop = document.getElementById('AnyraPop');
    if (!pop) return;

    let seen = false;
    try { seen = !!localStorage.getItem(KEY); } catch { /* private mode */ }
    if (seen) return;

    let shown = false;
    const remember = () => { try { localStorage.setItem(KEY, '1'); } catch { /* ignore */ } };

    // Never open over the menu, cart or any other drawer; try again a few seconds later.
    const busy = () => !!document.querySelector('header details[open], menu-drawer details[open], .menu-drawer[open], cart-drawer[open], .drawer[open], dialog[open], [data-drawer][open]');

    const open = () => {
      if (shown) return;
      if (busy()) { setTimeout(open, 4000); return; }
      shown = true;
      pop.hidden = false;
      requestAnimationFrame(() => pop.classList.add('is-open'));
      window.removeEventListener('scroll', onScroll);
      clearTimeout(timer);
      pop.querySelector('input[type="email"]')?.focus({ preventScroll: true });
    };

    const close = () => {
      pop.classList.remove('is-open');
      remember();
      setTimeout(() => { pop.hidden = true; }, 200);
    };

    const onScroll = () => {
      // Past the hero, or past a screen and a half if there is no hero.
      const hero = document.querySelector('anyra-hero, .anyra-hero, .slideshow-wrapper');
      const past = hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > window.innerHeight * 1.5;
      if (past) open();
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    const timer = setTimeout(open, parseInt(pop.dataset.delay || '30000', 10));

    pop.querySelectorAll('[data-anyra-pop-close]').forEach((b) => b.addEventListener('click', close));
    pop.addEventListener('click', (e) => { if (e.target === pop) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !pop.hidden) close(); });

    const form = pop.querySelector('form');
    const code = pop.querySelector('[data-anyra-pop-code]');
    const done = pop.querySelector('[data-anyra-pop-done]');

    form?.addEventListener('submit', (e) => {
      const email = form.querySelector('input[type="email"]')?.value;
      if (!email) return;
      e.preventDefault();
      // Best effort capture into Shopify customers. The confirmation shows
      // either way, so a network failure never leaves the visitor stuck.
      try {
        const fd = new FormData(form);
        fd.append('form_type', 'customer');
        fd.append('utf8', '✓');
        fetch('/contact', { method: 'POST', body: fd }).catch(() => {});
      } catch { /* ignore */ }
      form.hidden = true;
      remember();
      if (code) code.hidden = false; else if (done) done.hidden = false;
    });

    code?.addEventListener('click', function () {
      try { navigator.clipboard.writeText(pop.dataset.code || this.textContent.trim()); } catch { /* ignore */ }
      const hint = this.querySelector('.anyra-pop__hint');
      if (hint) hint.textContent = 'copied';
      setTimeout(close, 900);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
